var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container py-5"
  }, [_c('div', {
    staticClass: "jumbotron jumbotron-fluid bg-white"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 text-center"
  }, [_c('h1', {
    staticClass: "funko-not-found-title"
  }, [_vm._v("Page Not Found")]), _c('p', {
    staticClass: "funko-not-found-text"
  }, [_vm._v("No pudimos encontrar la página que buscas.")])]), _c('div', {
    staticClass: "col-12 d-flex justify-content-center"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/not-found.gif"),
      "alt": "john-travolta-meme"
    }
  })])])])])]);
}]

export { render, staticRenderFns }